import { render, staticRenderFns } from "./RelatedCourse.vue?vue&type=template&id=55ccd236&scoped=true&"
import script from "./RelatedCourse.vue?vue&type=script&lang=js&"
export * from "./RelatedCourse.vue?vue&type=script&lang=js&"
import style0 from "./RelatedCourse.vue?vue&type=style&index=0&id=55ccd236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ccd236",
  null
  
)

export default component.exports